import store from "../store/index";
//--------------------------
// get unused extra actions
//--------------------------
export default function getUnusedExtraActions(combatants) {
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat;
  let maxCA = this_store.config.max_ca + 1;
  let unused_action_count = 0;
  //----------
  // loop cas
  //----------
  for (let i = 1; i <= maxCA; i++) {
    // set ca name
    let ca_name = "ca_name" + i;
    let ca_type = "ca_type" + i;
    //---------------------------
    // get pending count this ca
    //---------------------------
    let pending_combatants = combatants.filter((a) => a[ca_name] == "pending");
    //--------------------------
    // get markers count this ca
    //---------------------------
    let marker_combatants = combatants.filter((a) => a[ca_type] == "marker");
    // console.log("non_blank_combatants = " + non_blank_combatants.length)
    // console.log("pending_combatants = " + pending_combatants.length)
    // console.log("marker_combatants = " + marker_combatants.length)
    //------------------------------------------------
    // where combatants with pending action or marker
    //------------------------------------------------
    if (pending_combatants.length > 0 || marker_combatants.length > 0) {
      //---------------------------------------------------------
      // unused action count for cur action = pendings + markers
      //---------------------------------------------------------
      unused_action_count =
        pending_combatants.length + marker_combatants.length;
      break;
    }
  }
  return unused_action_count;
}
